// extracted by mini-css-extract-plugin
export default {"footerContainer":"Footer_footerContainer__WPMg8","footerBottom":"Footer_footerBottom__qjjsX","copyright":"Footer_copyright__2WB24","legal":"Footer_legal__vwWtw"};